/**
 * The icon color vector: how a caller sets exact colors on a glyph (in the
 * spirit of SF Symbols' multicolor palettes). The contract:
 *
 * - No vector (or an empty one) → every element paints with currentColor,
 *   inheriting the surrounding text color as always.
 * - One color → every element uses it.
 * - Two or more → the glyph itself decides which of its strokes take which
 *   slot, and documents its slot layout in its docstring.
 *
 * A glyph never touches the vector directly: it calls
 * `strokePalette(props.colors)` — guaranteed to hold at least one entry —
 * and chains its slots so a missing one inherits the slot before it:
 *
 *   const palette = strokePalette(props.colors);
 *   const body = palette[0];
 *   const detail = palette[1] ?? body;
 *
 * Each entry is spread onto the element (or group) that owns the slot,
 * resolving to `stroke` (+ `strokeOpacity` when the color is translucent).
 */import Color from"web/shared/utils/Color";export function strokePalette(colors){if(colors==null||colors.length===0){return[{stroke:"currentColor"}];}return colors.map(strokeAttributesFor);}// The fill counterpart, for "-filled" glyph variants: same slot contract,
// resolving to fill (+ fillOpacity) instead of stroke.
export function fillPalette(colors){if(colors==null||colors.length===0){return[{fill:"currentColor"}];}return colors.map(fillAttributesFor);}function strokeAttributesFor(color){const opacity=color.getOpacity();if(opacity<1){return{stroke:color.toHex(),strokeOpacity:opacity};}return{stroke:color.toHex()};}function fillAttributesFor(color){const opacity=color.getOpacity();if(opacity<1){return{fill:color.toHex(),fillOpacity:opacity};}return{fill:color.toHex()};}